// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG } from "common/config";
import { COMMON_JS } from "common/scripts";

export const CUSTOMER_APIs = {
  getCrmLeadAssigned: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/WGFY2L2O2IOFE382",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  manageLeadAssigned: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/43XNE0WGZ4QUZUVV",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  getCrmLeadProfiles: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/054XKXP835731FWM",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  getCustomerOnMap: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/438Z5618L74978RF",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  removeCustomerPhoto: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/458S9085E53540GY",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  getCustomerPhotos: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/991M9250J22211EP",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update customer
  manageCustomerProfile: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/709S5073F13336FB",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // To get all customer details
  getCustomerProfiles: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/668D6510V91105XT",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To get all customer details
  getChallanCustomers: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/792C1465K91718NQ",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update Branch
  manageBranchProfile: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/v1/customer/branchprofile",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get customer Branches
  getBranchProfile: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/v1/customer/branchprofiles",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update customer
  manageCustomerType: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/513C4053D83312PC",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get customer Types
  getCustomerTypes: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/710T6972L66442XF",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // To create/update customer address
  manageCustomerAddresses: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/410Y2778T60362OG",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get customer address
  getCustomerAddresses: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/cu/v1/424W1574I97636OW",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },
};
